import { styled } from '@material-ui/core';

export const BaseStyledTable = styled('table')({
  borderCollapse: 'separate',
  borderSpacing: 0,
  tableLayout: 'fixed',
  width: '100%',
  minWidth: '600px',
  margin: 'var(--bui-space-4) 0',
  border: '1px solid var(--bui-border)',
  borderRadius: 'var(--bui-radius-2)',
  backgroundColor: 'var(--bui-bg-surface-1)',
  lineHeight: 1.4,

  '& td': {
    minWidth: '100px',
    borderBottom: '1px solid var(--bui-border)',
    padding: 'var(--bui-space-1) var(--bui-space-2)',
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    position: 'relative',
    fontFamily: 'var(--encore-body-font-stack)',
    color: 'var(--bui-fg-primary)',
    fontSize: 'var(--bui-font-size-3)',
    lineHeight: 1.4,
  },

  '& th': {
    minWidth: '100px',
    borderBottom: '1px solid var(--bui-border)',
    padding: 'var(--bui-space-1) var(--bui-space-2)',
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    position: 'relative',
    fontFamily: 'var(--encore-body-font-stack)',
    fontWeight: 600,
    fontSize: 'var(--bui-font-size-1)',
    lineHeight: 1.4,
    textAlign: 'left',
    backgroundColor: 'var(--bui-bg-surface-2)',
    color: 'var(--bui-fg-secondary)',
    letterSpacing: '0.025em',
  },

  '& td > p': {
    margin: 0,
  },

  '& tr:last-child td': {
    borderBottom: 'none',
  },

  '& tr:last-child th': {
    borderBottom: '1px solid var(--bui-border)',
  },
});
